import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface User {
  currentUser: {
    email: string;
    userName: string;
    firstName: string;
    lastName: string;
    userId: string;
  };
}

const initialState: User = {
  currentUser: {
    email: "",
    userName: "",
    firstName: "",
    lastName: "",
    userId: ""
  },
};

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<User["currentUser"]>) => {
      state.currentUser = action.payload;
    },
    updateCurrentUser: (
      state,
      action: PayloadAction<Partial<User["currentUser"]>>
    ) => {
      state.currentUser = { ...state.currentUser, ...action.payload };
    },
  },
});

export const { setCurrentUser, updateCurrentUser } = userSlice.actions;

export default userSlice.reducer;
